import React from 'react'
// components
import BusinessUnitsAPI from 'containers/BusinessUnits/layers/API/index'
import BusinessUnits from 'components/PageComponents/Settings/BusinessUnits/index'

const BusinessUnitsContainer: React.FC = () => {
  return (
    <BusinessUnitsAPI>
      <BusinessUnits />
    </BusinessUnitsAPI>
  )
}

export default BusinessUnitsContainer
